import { Autocomplete } from '@mui/material';

import { styled } from 'helpers';

export const StyledOptions = styled('li')`
  &.MuiAutocomplete-option {
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: 400;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    line-height: 20px;
    letter-spacing: 0.25px;
    min-height: 40px;
  }
  color: ${({ theme }) => theme.palette.blueGrey['900']};
  &.MuiAutocomplete-option.Mui-focused,
  &.MuiAutocomplete-option[aria-selected='true'],
  &.MuiAutocomplete-option[aria-selected='true'].Mui-focused {
    background: ${({ theme }) => theme.palette.grey['A50']};
  }
`;
export const SearchFieldStyled = styled(Autocomplete)`
  & .MuiOutlinedInput-root {
    padding: 0px;
    background: #ffffff;
    border: 1px solid ${({ theme }) => theme.palette.blueGrey['A200']};
    border-radius: 4px;
  }
  & .MuiInputAdornment-root {
    width: 24px;
    height: 24px;
    margin: 0 8px 0 16px;
    justify-content: center;
    .search {
      font-size: 14px;
      color: ${({ theme }) => theme.palette.blueGrey['A400']};
    }
  }
  & .MuiFormControl-root.MuiTextField-root .MuiInputBase-root.MuiOutlinedInput-root .MuiInputBase-input {
    padding-left: 0px;
  }
  & .MuiButtonBase-root.MuiIconButton-root.MuiAutocomplete-clearIndicator:hover {
    background: none;
  }
  & .MuiOutlinedInput-root .MuiAutocomplete-endAdornment {
    right: 12px;
  }
  & .removeSolid {
    color: ${({ theme }) => theme.palette.blueGrey['A400']};
  }
`;

SearchFieldStyled.displayName = 'SearchField';
